export interface ServiceType {
  id: number;
  name: string;
  description?: string;
  category?: string;
  estimatedTimeMinutes?: number;
  baseCost?: number;
  currentCost?: number;
  profitMarginPercentage?: number;
  isActive: boolean;
  status?: string;
  code?: string;
  createdAt: string;
  updatedAt?: string;
  createdBy?: string;
  updatedBy?: string;
}

export enum ServiceCategory {
  PREVENTIVA = 'Manutenção Preventiva',
  CORRETIVA = 'Manutenção Corretiva',
  ESTETICA = 'Estética'
}

export interface ApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
  timestamp: string;
}

export interface PaginatedResponse<T> {
  success: boolean;
  message: string;
  total: number;
  page: number;
  pageSize: number;
  data: T[];
  count: number;
  timestamp: string;
}

export interface ApiError {
  error: string;
}

export interface ServiceStats {
  totalServices: number;
  activeServices: number;
  inactiveServices: number;
  categoryStats: { [key: string]: number };
}

export interface PriceCalculation {
  serviceId: number;
  serviceName: string;
  baseCost?: number;
  currentCost?: number;
  profitMarginPercentage?: number;
  finalPrice: number;
}

export interface TimeCalculation {
  serviceCount: number;
  totalMinutes: number;
  totalHours: number;
}

